export default {
  currency: {
    items: [],
    loading: false,
  },
  loading: true,
  projectTypes: [],
  brandDetectionModels: [],
}
